__turbopack_context__.v({
  "btn-container": "styles-module-scss-module__pKWQ1q__btn-container",
  "slot-adv": "styles-module-scss-module__pKWQ1q__slot-adv",
});
